/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function (b, c) {
  var $ = b.jQuery || b.Cowboy || (b.Cowboy = {}),
    a;
  $.throttle = a = function (e, f, j, i) {
    var h,
      d = 0;
    if (typeof f !== "boolean") {
      i = j;
      j = f;
      f = c;
    }
    function g() {
      var o = this,
        m = +new Date() - d,
        n = arguments;
      function l() {
        d = +new Date();
        j.apply(o, n);
      }
      function k() {
        h = c;
      }
      if (i && !h) {
        l();
      }
      h && clearTimeout(h);
      if (i === c && m > e) {
        l();
      } else {
        if (f !== true) {
          h = setTimeout(i ? k : l, i === c ? e - m : e);
        }
      }
    }
    if ($.guid) {
      g.guid = j.guid = j.guid || $.guid++;
    }
    return g;
  };
  $.debounce = function (d, e, f) {
    return f === c ? a(d, e, false) : a(d, f, e !== false);
  };
})(this);

(function () {
  // Add custom code below this line

  // $('.product-form .product__submit__add').hide();

  setTimeout(function () {
    $(".custom-price-range").show();
    $(".custom-price-range .product__price").show();
  }, 500);

  setTimeout(function () {
    $(".price").show();
  }, 5000);

  setTimeout(function () {
    $("#standard-rugpad").click(function () {
      $(".sg-pro-access-quick-view-btn[data-attr-handle*='pad']")
        .parent()
        .prev()
        .find(".sg-pro-access-checkbox")
        .click();
    });

    $("#standard-rugpad_price").text(
      $('.sg-pro-access-quick-view-btn[data-attr-handle*="pad"]')
        .parent()
        .parent()
        .next()
        .find(".sg-pro-access-price")
        .text()
        .replace(" USD", "")
    );

    if (
      $(
        '#spiceaddonsappid .sg-pro-access-quick-view-btn[data-attr-handle*="sample"]'
      ).length
    ) {
      $(".swatchz").show();
    }

    if (
      $(
        '#spiceaddonsappid .sg-pro-access-quick-view-btn[data-attr-handle*="pad"]'
      ).length
    ) {
      $(".rugz").show();
    }
  }, 3000);

  $(".product__selectors .size-wrapper label").click(function () {
    var rugsize = $(this).find("span").text().toLowerCase();

    $('.sg-pro-access-quick-view-btn[data-attr-handle*="pad"]')
      .parent()
      .parent()
      .next()
      .find('.spice_select_variant_id option:contains("' + rugsize + '")')
      .prop("selected", true);

    $('.sg-pro-access-quick-view-btn[data-attr-handle*="pad"]')
      .parent()
      .parent()
      .next()
      .find(".spice_select_variant_id")
      .change();

    setTimeout(function () {
      $("#standard-rugpad_price").text(
        $('.sg-pro-access-quick-view-btn[data-attr-handle*="pad"]')
          .parent()
          .parent()
          .next()
          .find(".sg-pro-access-price")
          .text()
          .replace(" USD", "")
      );
    }, 50);
  });

  const rugInterval = setInterval(function () {
    var rugsizez = $(
      ".product__selectors .size-wrapper .radio__button input:checked~label"
    )
      .find("span")
      .text()
      .toLowerCase();

    $('.sg-pro-access-quick-view-btn[data-attr-handle*="pad"]')
      .parent()
      .parent()
      .next()
      .find('.spice_select_variant_id option:contains("' + rugsizez + '")')
      .prop("selected", true);

    $('.sg-pro-access-quick-view-btn[data-attr-handle*="pad"]')
      .parent()
      .parent()
      .next()
      .find(".spice_select_variant_id")
      .change();

    setTimeout(function () {
      $("#standard-rugpad_price").text(
        $('.sg-pro-access-quick-view-btn[data-attr-handle*="pad"]')
          .parent()
          .parent()
          .next()
          .find(".sg-pro-access-price")
          .text()
          .replace(" USD", "")
      );
    }, 50);
  }, 2000);

  // method to be executed;

  const cartInterval = setInterval(function () {
    var cleanText = $(
      '.cart-item__selected-options:first-child span:contains("Area")'
    )
      .text()
      .split("-")[0];
    // console.log(cleanText);

    $('.cart-item__selected-options:first-child span:contains("Area")').text(
      cleanText
    );

    $('.cart-item__property span:contains("Length")').hide();
    $('.cart-item__property span:contains("Length") + span').hide();
    $('.cart-item__property span:contains("Width")').hide();
    $('.cart-item__property span:contains("Width") + span').hide();

    $('.cart-item__property span:contains("Rug") + span').text("Included");
  }, 2000);

  // sg-pro-access-product

  // sg-pro-access-quick-view-btn data-attr-handle

  $(".order-sample").on("click", function (e) {
    e.preventDefault();

    $(".sg-pro-access-quick-view-btn[data-attr-handle*='sample']").click();
  });

  $(".tab-arrowz-prev").on("click", function () {
    $(this).parent().prev().find(".flickity-prev-next-button.previous").click();
  });

  $(".tab-arrowz-next").on("click", function () {
    $(this).parent().prev().find(".flickity-prev-next-button.next").click();
  });

  // Custom Rug Calculator

  $("#width-in, #length-in").on("keydown keyup change", function (e) {
    if (
      $(this).val() > 11 &&
      e.keyCode !== 46 && // keycode for delete
      e.keyCode !== 8 // keycode for backspace
    ) {
      e.preventDefault();
      $(this).val(11);
    }

    if (
      $(this).val() < 0 &&
      e.keyCode !== 46 && // keycode for delete
      e.keyCode !== 8 // keycode for backspace
    ) {
      e.preventDefault();
      $(this).val(0);
    }
  });

  $("#width-ft, #length-ft").on("keydown keyup change", function (e) {
    if (
      $(this).val() < 0 &&
      e.keyCode !== 46 && // keycode for delete
      e.keyCode !== 8 // keycode for backspace
    ) {
      e.preventDefault();
      $(this).val(0);
    }
  });

  /*****************************************************/
  //Code to test app: Measurement Price Calculator, can be remove

  //Calculate Measurement
  function getMeasurement() {
    var measurement = 0,
      isRugPad = $("#eoshProperties").is(":checked") ? true : false,
      appLength = $("#eo-sh-length").val(),
      appWidth = $("#eo-sh-width").val();

    if (appLength > 0 && appWidth > 0) {
      console.log(isRugPad);
      measurement = isRugPad
        ? $("#rugft").text() * ((appLength * appWidth) / 144)
        : appLength * appWidth;
    }

    return measurement;
  }

  //Pricing Calculator js
  setTimeout(function () {
    //init
    $("#eo-sh-length").attr("min", 0);
    $("#eo-sh-width").attr("min", 0);
    $("#eo-sh-length").val(0);
    $("#eo-sh-width").val(0);

    // $("#7110293323951-Binding-B").prop("checked", true); //select Binding B
    // $("#7110293323951-Color-Black").next().children().click(); //click Black color

    //Checkbox: Add a rug pad ($5 PER SQFT)
    $(".product__form").on("click", function (e) {
      const elId = e.target.id.toLowerCase();
      if (elId === "eoshproperties") {
        $("#eoshProperties").val(getMeasurement());
      }
    });

    //Input: Width + Length changes
    $("#eo-sh-length, #eo-sh-width").change(function () {
      //console.log( appLength +' x '+ appWidth );

      //update rug pad ($5 PER SQFT)
      $("eoshProperties").val(getMeasurement());
    });

    // On Page Load

    var width_in =
      Number($("#width-ft").val()) * 12 + Number($("#width-in").val());

    var length_in =
      Number($("#length-ft").val()) * 12 + Number($("#length-in").val());

    var square_in = width_in * length_in;
    var square_ft = (width_in * length_in) / 144;

    var calculated_price = Number((square_in * 0.17).toFixed(2)).toLocaleString(
      "en-US",
      { maximumFractionDigits: 2, minimumFractionDigits: 2 }
    );

    $("#width-total").text(width_in);
    $("#length-total").text(length_in);
    $("#square-in").text(square_in);
    $("#square-ft").text(square_ft);

    $("#eo-sh-width").val(width_in);
    $("#eo-sh-length").val(length_in);

    $("#calculated-price").text($(".eo-sh-amount").text());

    // $(".quantity__input").val(square_in);

    $("#custom-size").val(
      $("#width-ft").val() +
        "." +
        $("#width-in").val() +
        "' X " +
        $("#length-ft").val() +
        "." +
        $("#length-in").val() +
        "'"
    );

    // Sync input states

    $(".standard-notez.custom-rugz").show();

    $("#custom-rugpad").click(function () {
      $("#eoshProperties").click();
      setTimeout(function () {
        $("#calculated-price").text($(".eo-sh-amount").text());
      }, 50);
    });

    $(".selector-wrapper label").click(function () {
      checkStock();
      setTimeout(function () {
        $("#calculated-price").text($(".eo-sh-amount").text());
      }, 50);
    });

    function checkStock() {
      var myJson;
      var token =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjQiLCJuYmYiOjE2NTExNjM5NDQsImV4cCI6MjI1NTk2Mzk0NCwiaWF0IjoxNjUxMTYzOTQ0fQ.BTllBZ4A61yho2uQiO2aKltTvtvbSDXVrFXx9zXgmbA";

      $.ajax({
        url: "https://starkdata.starkcarpet.com/AshleyStarkItemSampleInventory",
        method: "GET",
        headers: { Authorization: "Bearer " + token },
        data: { ITEMID: $(".sku").text() },
        success: function (response) {
          myJson = response;
          console.log(myJson);
          var parsedResponse = JSON.parse(response);

          var availableIn = Math.floor(
            parsedResponse[0]["ITEM INVENTORY"][0].AVAILABLE
          );

          console.log(availableIn);

          if ($("#square-in").length) {
            if (parseInt($("#square-in").text()) >= availableIn) {
              $(".error-messages").html(
                'Unfortunately, we do not have enough inventory to fulfill your request. Please contact customer service for further assistance at <a href="mailto:customerservice@ashleystarkhome.com">customerservice@ashleystarkhome.com</a> or 855-ASH-STRK.'
              );
              $(".error-messages").slideDown();
              $(".measure-input").addClass("red");
              $(".product__submit__add").addClass("disabled");
            } else if (parseInt($("#square-in").text()) <= 0) {
              $(".product__submit__add").addClass("disabled");
            } else {
              $(".error-messages").slideUp();
              $(".measure-input").removeClass("red");
              $(".product__submit__add").removeClass("disabled");
            }
          }
        },
      });
    }

    setTimeout(function () {
      checkStock();
    }, 3000);

    // On Values change

    $("#width-ft, #width-in, #length-ft, #length-in").on(
      "keyup",
      $.throttle(1000, function () {
        var width_in =
          Number($("#width-ft").val()) * 12 + Number($("#width-in").val());

        var length_in =
          Number($("#length-ft").val()) * 12 + Number($("#length-in").val());

        var square_in = width_in * length_in;
        var square_ft = (width_in * length_in) / 144;

        var calculated_price = Number(
          (square_in * 0.17).toFixed(2)
        ).toLocaleString("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });

        $("#width-total").text(width_in);
        $("#length-total").text(length_in);
        $("#square-in").text(square_in);
        $("#square-ft").text(square_ft);

        $("#eo-sh-width").val(width_in).change();
        $("#eo-sh-length").val(length_in).change();

        $("#calculated-price").text($(".eo-sh-amount").text());

        // $(".quantity__input").val(square_in);

        $("#custom-size").val(
          $("#width-ft").val() +
            "." +
            $("#width-in").val() +
            "' X " +
            $("#length-ft").val() +
            "." +
            $("#length-in").val() +
            "'"
        );

        checkStock();
      })
    );

    // Error Messages button

    // $('.product-form .product__submit__add').show();

    // if ($('.product-form .quantity__input').val() == 0) {
    //   $('.product-form .product__submit__add').prop("disabled", true);
    // }

    // $('.product-form .quantity__input').on('keydown keyup change', function(e){
    //   if ($('.product-form .quantity__input').val() != 0) {
    //     $('.product-form .product__submit__add').prop("disabled", false);
    //   } else {
    //     $('.product-form .product__submit__add').prop("disabled", true);
    //   }
    // });

    // $('.product-form .select-popout__toggle').on('click', function(e){
    //   $('.product-form .select-popout__toggle').css("border-color", "#ccc");
    // });

    // $('.product-form div').on('click', function(e){

    //   setTimeout(function(){
    //   if ($('.product-form .quantity__input').val() != 0) {
    //     $('.product-form .product__submit__add').prop("disabled", false);
    //   } else {
    //     $('.product-form .product__submit__add').prop("disabled", true);
    //   }
    // }, 50);

    // });

    // $('.product-form .product__submit').on('click', function(e){

    //     if ($('.product-form .quantity__input').val() == 0) {
    //       $('.select-popout__toggle').css("border-color", "#ff0000");
    //     }

    // });

    // $('.custom-rug-form .product__submit').on('click', function(e){

    // setTimeout(function(){
    // if ($('.product-form .quantity__input').val() != 0) {
    // }
    // }, 100);

    // });
  }, 3000);

  // Custom PLP

  var colsegment = $(location).attr("href").split("/").splice(0, 5).join("/");

  const cfilter = document.getElementById("filter-vmg");
  const cplp = document.getElementById("plp-plc");
  const oseid = "oseid";
  var url = window.location.href;

  var cparamsurl = url.split("?");

  if (cparamsurl.length > 1 && cparamsurl[1] !== "") {
    console.log("params found");
    cplp.classList.add("hidden");
    $(".collection__sidebar__slider").addClass("expanded");
    $(".product-grid .product-item").show();

    if (!cparamsurl[1].includes(oseid)) {
      $(".custom-plp-section").hide();
    }
  } else {
    $(".custom-plp-section").prependTo("#plp-plc");

    //hide no results
    $("#plp-plc").next(".no-results").hide();
  }

  // cfilter.addEventListener('click', () => {
  //     cplp.classList.add('hidden');
  // });

  /*************************************************** */

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
